/* eslint-disable import/no-anonymous-default-export */
export default {
	styleOverrides: {
		root: {
			width: '0px',
		},
	},
};
